<!-- src/components/portafolio/FarmaciaPlus.vue -->
<template>
  <div class="farmacia-plus">
    <!-- Botón de regreso -->
    <v-btn fab small class="back-button" @click="$router.push('/portafolio')">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <!-- Header con navegación REDISEÑADO -->
    <v-app-bar dark app height="70" class="premium-header">
      <div class="logo-container">
        <div class="logo-icon">
          <v-icon size="24">mdi-pharmacy</v-icon>
        </div>
        <span class="logo-text">FARMACIA<span class="logo-highlight">PLUS</span></span>
      </div>

      <div class="nav-menu d-none d-md-flex">
        <a href="#" class="nav-item" @click.prevent="scrollToTop">Inicio</a>
        <a href="#" class="nav-item" @click.prevent="scrollToSection('productos')"
          >Productos</a
        >
        <a href="#" class="nav-item" @click.prevent="verPromociones">Promociones</a>
        <a href="#" class="nav-item" @click.prevent="scrollToSection('servicios')"
          >Salud</a
        >
        <a href="#" class="nav-item" @click.prevent="scrollToSection('contacto')"
          >Contacto</a
        >
      </div>

      <v-spacer></v-spacer>

      <div class="actions-menu d-none d-md-flex">
        <button class="action-btn" @click="buscarProductos">
          <v-icon size="20">mdi-magnify</v-icon>
        </button>
        <button class="action-btn cart-btn" @click="verCarrito">
          <v-icon size="20">mdi-cart-outline</v-icon>
          <span class="action-badge cart-badge">3</span>
        </button>
        <button class="account-btn" @click="miCuenta">
          <v-icon size="18">mdi-account</v-icon>
          Mi cuenta
        </button>
      </div>

      <button class="mobile-menu-btn hidden-md-and-up" @click="drawer = true">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </v-app-bar>

    <!-- Drawer móvil -->
    <v-navigation-drawer v-model="drawer" app temporary class="mobile-drawer-premium">
      <div class="drawer-header-premium">
        <div class="drawer-logo">
          <v-icon color="#4CAF50">mdi-pharmacy</v-icon>
          <span>FarmaciaPlus</span>
        </div>
        <button class="drawer-close" @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </button>
      </div>
      <div class="drawer-menu">
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToTop();
          "
        >
          <v-icon>mdi-home</v-icon>
          <span>Inicio</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('productos');
          "
        >
          <v-icon>mdi-pill</v-icon>
          <span>Productos</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            verPromociones();
          "
        >
          <v-icon>mdi-sale</v-icon>
          <span>Promociones</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('servicios');
          "
        >
          <v-icon>mdi-heart</v-icon>
          <span>Salud</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('contacto');
          "
        >
          <v-icon>mdi-phone</v-icon>
          <span>Contacto</span>
        </a>
      </div>
      <div class="drawer-footer">
        <button class="drawer-cart-btn" @click="verCarrito">
          <v-icon>mdi-cart</v-icon>
          Carrito (3)
        </button>
        <button class="drawer-account-btn" @click="miCuenta">
          <v-icon>mdi-account</v-icon>
          Mi cuenta
        </button>
      </div>
    </v-navigation-drawer>

    <!-- Hero Section -->
    <v-parallax
      src="https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=1600"
      height="500"
    >
      <v-container fill-height>
        <v-row align="center" justify="center" class="text-center">
          <v-col cols="12" md="8">
            <div class="hero-content">
              <h1 class="display-3 font-weight-bold white--text mb-4">Farmacia Plus</h1>
              <h2 class="headline white--text mb-6 font-weight-light">
                Tu salud, nuestra prioridad. Medicamentos al mejor precio con delivery
                gratis
              </h2>
              <div class="search-box">
                <v-text-field
                  v-model="searchTerm"
                  placeholder="Buscar medicamentos, productos de cuidado personal..."
                  outlined
                  rounded
                  solo
                  dark
                  append-icon="mdi-magnify"
                  class="search-input"
                  @click:append="buscarProductos"
                  @keyup.enter="buscarProductos"
                ></v-text-field>
              </div>
              <v-row justify="center" class="mt-4">
                <v-col cols="auto">
                  <v-btn
                    color="#FF9800"
                    dark
                    x-large
                    rounded
                    elevation-10
                    @click="scrollToSection('productos')"
                  >
                    <v-icon left>mdi-pill</v-icon>
                    Comprar ahora
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    outlined
                    dark
                    x-large
                    rounded
                    @click="scrollToSection('servicios')"
                  >
                    <v-icon left>mdi-information</v-icon>
                    Saber más
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-parallax>

    <!-- Beneficios -->
    <v-container class="mt-n8">
      <v-card elevation="10" class="benefits-card">
        <v-container>
          <v-row>
            <v-col
              v-for="(beneficio, idx) in beneficios"
              :key="idx"
              cols="6"
              md="3"
              class="text-center"
            >
              <div class="benefit-item">
                <v-icon size="40" :color="beneficio.color">{{ beneficio.icono }}</v-icon>
                <h4 class="title mt-2">{{ beneficio.titulo }}</h4>
                <p class="caption grey--text">{{ beneficio.descripcion }}</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <!-- Categorías -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Categorías destacadas</h2>
          <p class="subtitle-1 grey--text">Encuentra lo que necesitas por categoría</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(categoria, idx) in categorias" :key="idx" cols="6" sm="4" md="2">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 8 : 2"
              class="category-card text-center pa-3"
              :class="{ 'category-card-hover': hover }"
              @click="filtrarPorCategoria(categoria.nombre)"
            >
              <v-icon size="48" :color="hover ? '#4CAF50' : '#666'">
                {{ categoria.icono }}
              </v-icon>
              <p class="mt-2 mb-0 font-weight-bold caption">{{ categoria.nombre }}</p>
              <span class="caption grey--text">{{ categoria.cantidad }} productos</span>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Productos destacados -->
    <v-container id="productos" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Productos destacados</h2>
          <p class="subtitle-1 grey--text">Los más vendidos con los mejores precios</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          v-for="producto in productosDestacados"
          :key="producto.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 4"
              class="product-card"
              :class="{ 'product-card-hover': hover }"
            >
              <div class="product-badge" v-if="producto.oferta">
                <v-chip small color="#FF9800" dark>-{{ producto.descuento }}%</v-chip>
              </div>
              <div class="product-badge-left" v-if="producto.receta">
                <v-chip small color="#F44336" dark>Requiere receta</v-chip>
              </div>

              <v-img :src="producto.imagen" height="180" class="product-image" cover>
                <div class="product-overlay" v-if="hover">
                  <v-btn
                    fab
                    small
                    dark
                    color="#4CAF50"
                    @click.stop="verProducto(producto)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </div>
              </v-img>

              <v-card-title class="pb-0 text-subtitle-1 font-weight-bold">
                {{ producto.nombre }}
              </v-card-title>

              <v-card-text>
                <p class="body-2 grey--text mb-2">{{ producto.descripcion }}</p>
                <div class="d-flex align-center justify-space-between mt-3">
                  <div>
                    <span class="title font-weight-bold" style="color: #4caf50"
                      >S/ {{ producto.precio }}</span
                    >
                    <span v-if="producto.precio_anterior" class="caption grey--text ml-2">
                      <s>S/ {{ producto.precio_anterior }}</s>
                    </span>
                  </div>
                  <v-chip
                    small
                    outlined
                    :color="producto.stock === 'En stock' ? '#4CAF50' : '#FF9800'"
                  >
                    {{ producto.stock }}
                  </v-chip>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  block
                  color="#4CAF50"
                  dark
                  rounded
                  @click.stop="agregarAlCarrito(producto)"
                >
                  <v-icon left>mdi-cart-plus</v-icon>
                  Agregar al carrito
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-8">
        <v-col cols="auto">
          <v-btn color="#4CAF50" outlined large rounded @click="verTodosProductos">
            Ver todos los productos
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- Promociones especiales -->
    <v-container class="mt-12">
      <v-card color="#E8F5E9" class="pa-8">
        <v-row align="center">
          <v-col cols="12" md="6">
            <h2 class="display-1 font-weight-bold mb-4" style="color: #2e7d32">
              Promociones especiales
            </h2>
            <p class="headline font-weight-light mb-4">
              ¡Lleva 3 pagas 2 en toda la línea de vitaminas!
            </p>
            <p class="subtitle-1 mb-4">
              Promoción válida hasta el 30 de junio. Stock limitado.
            </p>
            <v-btn color="#FF9800" dark x-large rounded @click="verPromociones"
              >Ver promociones</v-btn
            >
          </v-col>
          <v-col cols="12" md="6">
            <v-img
              src="https://images.unsplash.com/photo-1576602976047-174e57a47881?w=600"
              height="250"
              class="rounded-lg"
              cover
            ></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- Servicios adicionales -->
    <v-container id="servicios" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Servicios adicionales</h2>
          <p class="subtitle-1 grey--text">Más que una farmacia, cuidamos tu salud</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          v-for="(servicio, idx) in serviciosAdicionales"
          :key="idx"
          cols="12"
          sm="6"
          md="3"
        >
          <v-card class="service-card text-center pa-4" elevation="3">
            <v-icon size="48" :color="servicio.color">{{ servicio.icono }}</v-icon>
            <h3 class="title mt-3">{{ servicio.titulo }}</h3>
            <p class="body-2 grey--text mt-2">{{ servicio.descripcion }}</p>
            <v-btn text :color="servicio.color" @click="verServicio(servicio)"
              >Más información</v-btn
            >
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Blog de salud -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Consejos de salud</h2>
          <p class="subtitle-1 grey--text">
            Artículos que te ayudarán a cuidar tu bienestar
          </p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(articulo, idx) in articulosSalud" :key="idx" cols="12" md="4">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 4"
              class="blog-card"
              @click="verArticulo(articulo)"
            >
              <v-img :src="articulo.imagen" height="200" cover>
                <div class="blog-overlay" v-if="hover">
                  <v-btn fab small dark color="#4CAF50">
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </v-img>
              <v-card-title class="pb-0">{{ articulo.titulo }}</v-card-title>
              <v-card-text>
                <p class="body-2 grey--text">{{ articulo.resumen }}</p>
                <div class="d-flex align-center mt-2">
                  <v-icon small class="mr-1">mdi-calendar</v-icon>
                  <span class="caption">{{ articulo.fecha }}</span>
                  <v-icon small class="ml-2 mr-1">mdi-eye</v-icon>
                  <span class="caption">{{ articulo.vistas }} vistas</span>
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Testimonios -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Opiniones de nuestros clientes</h2>
          <p class="subtitle-1 grey--text">Miles de clientes confían en nosotros</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(testimonio, idx) in testimonios" :key="idx" cols="12" md="4">
          <v-card class="testimonial-card pa-4" elevation="3">
            <v-card-text>
              <v-icon color="#FF9800" size="32" class="mb-2"
                >mdi-format-quote-open</v-icon
              >
              <p class="body-1 font-italic">"{{ testimonio.texto }}"</p>
              <div class="d-flex align-center mt-4">
                <v-avatar size="50">
                  <v-img :src="testimonio.avatar"></v-img>
                </v-avatar>
                <div class="ml-3">
                  <p class="mb-0 font-weight-bold">{{ testimonio.nombre }}</p>
                  <v-rating
                    :value="testimonio.rating"
                    readonly
                    dense
                    small
                    color="#FFD700"
                  ></v-rating>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Newsletter -->
    <v-container class="mt-12">
      <v-card color="#2E7D32" dark class="pa-8 text-center">
        <v-card-title class="display-1 justify-center font-weight-light"
          >¡Suscríbete a nuestro newsletter!</v-card-title
        >
        <v-card-text class="subtitle-1"
          >Recibe ofertas exclusivas y consejos de salud directamente en tu
          correo</v-card-text
        >
        <v-form class="mt-4">
          <v-row justify="center">
            <v-col cols="12" md="5">
              <v-text-field
                v-model="newsletterEmail"
                label="Tu correo electrónico"
                outlined
                dark
                solo
                placeholder="ejemplo@correo.com"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="#FF9800"
                dark
                x-large
                rounded
                block
                @click="suscribirNewsletter"
                >Suscribirme</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <p class="caption mt-4">
          No enviaremos spam. Puedes cancelar tu suscripción en cualquier momento.
        </p>
      </v-card>
    </v-container>

    <!-- Footer -->
    <v-footer id="contacto" color="#1B5E20" dark class="mt-12">
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-icon large class="mb-2">mdi-pharmacy</v-icon>
            <h3 class="title">Farmacia Plus</h3>
            <p class="caption mt-2">Tu salud, nuestra prioridad desde 2020</p>
            <div class="mt-3">
              <v-btn icon dark class="mr-2"><v-icon>mdi-facebook</v-icon></v-btn>
              <v-btn icon dark class="mr-2"><v-icon>mdi-instagram</v-icon></v-btn>
              <v-btn icon dark class="mr-2"><v-icon>mdi-whatsapp</v-icon></v-btn>
              <v-btn icon dark><v-icon>mdi-youtube</v-icon></v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Productos</h3>
            <v-list dense dark>
              <v-list-item v-for="cat in categorias.slice(0, 4)" :key="cat.nombre">
                <v-list-item-content class="caption">{{
                  cat.nombre
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Servicios</h3>
            <v-list dense dark>
              <v-list-item
                v-for="serv in serviciosAdicionales.slice(0, 3)"
                :key="serv.titulo"
              >
                <v-list-item-content class="caption">{{
                  serv.titulo
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Contacto</h3>
            <p class="caption">
              <v-icon small class="mr-1">mdi-phone</v-icon> +51 928 180 748<br />
              <v-icon small class="mr-1">mdi-whatsapp</v-icon> +51 987 654 321<br />
              <v-icon small class="mr-1">mdi-email</v-icon> ventas@farmaciaplus.com
            </p>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Horario</h3>
            <p class="caption">
              Lun - Vie: 8am - 9pm<br />
              Sáb: 9am - 8pm<br />
              Dom: 9am - 2pm<br />
              Delivery 24/7
            </p>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>
        <div class="text-center caption">
          © 2024 Farmacia Plus - Todos los derechos reservados. <br />"Tu salud es nuestra
          prioridad"
        </div>
      </v-container>
    </v-footer>

    <!-- Dialog de confirmación -->
    <v-dialog v-model="dialogConfirmacion" max-width="400">
      <v-card>
        <v-card-title class="headline success--text">
          <v-icon left color="success" large>mdi-check-circle</v-icon>
          ¡Producto agregado!
        </v-card-title>
        <v-card-text>
          {{ productoAgregado }} ha sido agregado al carrito de compras. <br /><br />
          ¿Deseas seguir comprando o proceder al pago?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4CAF50" text @click="dialogConfirmacion = false"
            >Seguir comprando</v-btn
          >
          <v-btn color="#4CAF50" dark @click="irAlCarrito">Ver carrito</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "FarmaciaPlus",
  data() {
    return {
      drawer: false,
      searchTerm: "",
      dialogConfirmacion: false,
      newsletterEmail: "",
      productoAgregado: "",
      beneficios: [
        {
          icono: "mdi-truck-fast",
          titulo: "Delivery gratis",
          descripcion: "En compras mayores a S/ 100",
          color: "#FF9800",
        },
        {
          icono: "mdi-clock-outline",
          titulo: "Atención 24/7",
          descripcion: "Pedidos las 24 horas",
          color: "#4CAF50",
        },
        {
          icono: "mdi-shield-check",
          titulo: "Productos originales",
          descripcion: "Garantía de autenticidad",
          color: "#2196F3",
        },
        {
          icono: "mdi-cash",
          titulo: "Mejor precio",
          descripcion: "Precios competitivos",
          color: "#9C27B0",
        },
      ],
      categorias: [
        { nombre: "Medicamentos", icono: "mdi-pill", cantidad: 245 },
        { nombre: "Vitaminas", icono: "mdi-database", cantidad: 89 },
        { nombre: "Cuidado personal", icono: "mdi-face", cantidad: 156 },
        { nombre: "Primeros auxilios", icono: "mdi-medical-bag", cantidad: 67 },
        { nombre: "Bebé", icono: "mdi-baby", cantidad: 98 },
        { nombre: "Herbolaria", icono: "mdi-leaf", cantidad: 123 },
      ],
      productosDestacados: [
        {
          id: 1,
          nombre: "Paracetamol 500mg",
          descripcion: "Analgésico y antipirético para aliviar el dolor y la fiebre",
          precio: 12.9,
          precio_anterior: 18.5,
          oferta: true,
          descuento: 30,
          stock: "En stock",
          receta: false,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=300",
        },
        {
          id: 2,
          nombre: "Ibuprofeno 400mg",
          descripcion: "Antiinflamatorio para dolores musculares y articulares",
          precio: 15.9,
          precio_anterior: 22.0,
          oferta: true,
          descuento: 28,
          stock: "En stock",
          receta: false,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=300",
        },
        {
          id: 3,
          nombre: "Amoxicilina 500mg",
          descripcion: "Antibiótico de amplio espectro",
          precio: 35.9,
          precio_anterior: null,
          oferta: false,
          stock: "Stock limitado",
          receta: true,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=300",
        },
        {
          id: 4,
          nombre: "Vitamina C 1000mg",
          descripcion: "Refuerza el sistema inmunológico",
          precio: 28.9,
          precio_anterior: 45.0,
          oferta: true,
          descuento: 36,
          stock: "En stock",
          receta: false,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=300",
        },
        {
          id: 5,
          nombre: "Complejo B",
          descripcion: "Vitaminas B1, B6, B12 para energía y metabolismo",
          precio: 32.9,
          precio_anterior: 49.0,
          oferta: true,
          descuento: 33,
          stock: "En stock",
          receta: false,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=300",
        },
        {
          id: 6,
          nombre: "Omeprazol 20mg",
          descripcion: "Para el tratamiento de acidez y reflujo",
          precio: 25.9,
          precio_anterior: null,
          oferta: false,
          stock: "En stock",
          receta: false,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=300",
        },
        {
          id: 7,
          nombre: "Losartán 50mg",
          descripcion: "Para la presión arterial alta",
          precio: 42.9,
          precio_anterior: 65.0,
          oferta: true,
          descuento: 34,
          stock: "Stock limitado",
          receta: true,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=300",
        },
        {
          id: 8,
          nombre: "Metformina 850mg",
          descripcion: "Para el control de la diabetes",
          precio: 38.9,
          precio_anterior: null,
          oferta: false,
          stock: "En stock",
          receta: true,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=300",
        },
      ],
      serviciosAdicionales: [
        {
          icono: "mdi-truck-delivery",
          titulo: "Delivery a domicilio",
          descripcion: "Recibe tus medicamentos en la puerta de tu casa",
          color: "#FF9800",
        },
        {
          icono: "mdi-test-tube",
          titulo: "Pruebas rápidas",
          descripcion: "Glucosa, presión arterial y más",
          color: "#4CAF50",
        },
        {
          icono: "mdi-account-voice",
          titulo: "Consulta farmacéutica",
          descripcion: "Asesoría profesional gratuita",
          color: "#2196F3",
        },
        {
          icono: "mdi-cash-register",
          titulo: "Pago contra entrega",
          descripcion: "Paga al recibir tu pedido",
          color: "#9C27B0",
        },
      ],
      articulosSalud: [
        {
          titulo: "Cómo fortalecer tu sistema inmunológico",
          resumen:
            "Consejos prácticos para mantener tus defensas altas durante todo el año",
          fecha: "15/06/2024",
          vistas: 1245,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=600",
        },
        {
          titulo: "Vitaminas esenciales para el invierno",
          resumen: "Descubre qué vitaminas necesitas para enfrentar la temporada de frío",
          fecha: "10/06/2024",
          vistas: 987,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=600",
        },
        {
          titulo: "Primeros auxilios en casa",
          resumen: "Lo que debe tener tu botiquín para emergencias",
          fecha: "05/06/2024",
          vistas: 2341,
          imagen: "https://images.unsplash.com/photo-1584308666744-24d5c6de3f47?w=600",
        },
      ],
      testimonios: [
        {
          nombre: "María Gonzáles",
          texto:
            "Excelente servicio, los pedidos llegan rápido y los precios son muy competitivos.",
          rating: 5,
          avatar: "https://randomuser.me/api/portraits/women/1.jpg",
        },
        {
          nombre: "Carlos Ruiz",
          texto:
            "Me encanta la variedad de productos y las promociones que tienen. Muy recomendados.",
          rating: 5,
          avatar: "https://randomuser.me/api/portraits/men/2.jpg",
        },
        {
          nombre: "Ana María Torres",
          texto:
            "El delivery es súper rápido y los productos son originales. Compro aquí siempre.",
          rating: 5,
          avatar: "https://randomuser.me/api/portraits/women/3.jpg",
        },
      ],
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    buscarProductos() {
      if (this.searchTerm) {
        alert(`Buscando: ${this.searchTerm}`);
        this.scrollToSection("productos");
      }
    },
    filtrarPorCategoria(categoria) {
      alert(`Mostrando productos de: ${categoria}`);
      this.scrollToSection("productos");
    },
    verProducto(producto) {
      alert(`Ver detalles de: ${producto.nombre}`);
    },
    verTodosProductos() {
      alert("Mostrando todos los productos disponibles");
    },
    verPromociones() {
      alert("Mostrando todas las promociones especiales");
    },
    verServicio(servicio) {
      alert(`Más información sobre: ${servicio.titulo}`);
    },
    verArticulo(articulo) {
      alert(`Leyendo: ${articulo.titulo}`);
    },
    verCarrito() {
      alert("Redirigiendo al carrito de compras");
    },
    miCuenta() {
      alert("Ir a mi cuenta");
    },
    agregarAlCarrito(producto) {
      this.productoAgregado = producto.nombre;
      this.dialogConfirmacion = true;
    },
    irAlCarrito() {
      this.dialogConfirmacion = false;
      alert("Redirigiendo al carrito de compras");
    },
    suscribirNewsletter() {
      if (this.newsletterEmail && /.+@.+\..+/.test(this.newsletterEmail)) {
        alert(
          "¡Gracias por suscribirte! Recibirás nuestras ofertas y consejos de salud."
        );
        this.newsletterEmail = "";
      } else {
        alert("Por favor ingresa un email válido");
      }
    },
  },
};
</script>

<style scoped>
.farmacia-plus {
  background: #f8f9fa;
  min-height: 100vh;
}

/* Botón de regreso */
.back-button {
  position: fixed;
  top: 85px;
  left: 24px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  color: #4caf50;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.back-button:hover {
  background: #4caf50;
  color: white;
  transform: translateX(-3px);
}

/* Header Premium */
.premium-header {
  background: rgba(27, 94, 32, 0.96) !important;
  backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(76, 175, 80, 0.3);
  height: 70px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
}
.premium-header .v-toolbar__content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 32px;
  height: 70px !important;
  display: flex;
  align-items: center;
}

/* Logo */
.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #4caf50, #2e7d32);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}
.logo-icon .v-icon {
  color: white;
}
.logo-text {
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #fff, #ccc);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.logo-highlight {
  color: #4caf50;
  background: none;
  -webkit-background-clip: unset;
  background-clip: unset;
}

/* Menú central */
.nav-menu {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.05);
  padding: 4px 12px;
  border-radius: 50px;
  margin: 0 24px;
}
.nav-item {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 0.85rem;
  padding: 8px 16px;
  border-radius: 40px;
  transition: all 0.3s ease;
  cursor: pointer;
}
.nav-item:hover {
  color: #ff9800;
  background: rgba(255, 152, 0, 0.15);
}

/* Acciones derecha */
.actions-menu {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.action-btn {
  position: relative;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
}
.action-btn:hover {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
  transform: translateY(-2px);
}
.action-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ff9800;
  color: white;
  font-size: 0.65rem;
  font-weight: 600;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.account-btn {
  background: linear-gradient(135deg, #4caf50, #2e7d32);
  border: none;
  padding: 6px 18px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  margin-left: 8px;
}
.account-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

/* Botón menú móvil */
.mobile-menu-btn {
  background: transparent;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.mobile-menu-btn span {
  width: 22px;
  height: 2px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.mobile-menu-btn:hover span {
  background: #ff9800;
}

/* Drawer móvil */
.mobile-drawer-premium {
  background: #0d3b0f;
  width: 280px;
}
.drawer-header-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.drawer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
}
.drawer-close {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
}
.drawer-close:hover {
  background: rgba(255, 152, 0, 0.3);
}
.drawer-menu {
  padding: 16px;
}
.drawer-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  margin: 4px 0;
  border-radius: 12px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  cursor: pointer;
}
.drawer-item:hover {
  background: rgba(255, 152, 0, 0.15);
  color: #ff9800;
}
.drawer-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.drawer-cart-btn,
.drawer-account-btn {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  padding: 10px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.drawer-cart-btn:hover {
  background: rgba(255, 152, 0, 0.3);
}
.drawer-account-btn {
  background: linear-gradient(135deg, #4caf50, #2e7d32);
}
.drawer-account-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

/* Resto de estilos */
.hero-content {
  background: rgba(0, 0, 0, 0.4);
  padding: 40px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}
.search-box {
  max-width: 600px;
  margin: 0 auto;
}
.search-input >>> .v-input__control {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 30px;
}
.benefits-card {
  margin-top: -40px;
  background: white;
  border-radius: 20px;
  position: relative;
  z-index: 10;
}
.benefit-item {
  padding: 15px;
}
.category-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  height: 100%;
}
.category-card-hover {
  transform: translateY(-5px);
  background: #e8f5e9;
}
.product-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  height: 100%;
}
.product-card-hover {
  transform: translateY(-5px);
}
.product-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}
.product-badge-left {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
.product-image {
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
}
.product-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.service-card {
  transition: transform 0.3s ease;
  height: 100%;
  border-radius: 15px;
}
.service-card:hover {
  transform: translateY(-5px);
}
.blog-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  overflow: hidden;
  height: 100%;
}
.blog-card:hover {
  transform: translateY(-5px);
}
.blog-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.testimonial-card {
  transition: transform 0.3s ease;
  height: 100%;
  border-radius: 15px;
}
.testimonial-card:hover {
  transform: translateY(-5px);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.category-card,
.product-card,
.service-card,
.blog-card,
.testimonial-card {
  animation: fadeIn 0.6s ease;
}

@media (max-width: 960px) {
  .premium-header .v-toolbar__content {
    padding: 0 20px;
  }
}
@media (max-width: 600px) {
  .display-3 {
    font-size: 2rem !important;
  }
  .display-1 {
    font-size: 1.8rem !important;
  }
  .hero-content {
    padding: 20px;
  }
  .benefits-card {
    margin-top: -20px;
  }
  .product-card {
    margin-bottom: 16px;
  }
  .logo-text {
    font-size: 0.9rem;
  }
  .logo-icon {
    width: 30px;
    height: 30px;
  }
  .back-button {
    top: 80px;
    left: 16px;
  }
}

::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background: #2e7d32;
}
</style>
